export const getPrimaryPax = (state) => state.requisitionTravel.travellerDetails.primaryPax;
export const getTripTagsUserData = (state) => state.requisitionTravel.tripTags.userData;
export const getSearchData = (state) => state.requisitionTravel.searchData;
export const getTravellerDetails = (state) => state.requisitionTravel.travellerDetails;
export const getTravelReasons = (state) => state.requisitionTravel.travelReasons.userData;
export const getApprovalDetails = (state) => state.requisitionTravel.approvalDetails;
